import { Injectable } from "@angular/core"

@Injectable()
export class StandardsService {
    constructor() {}

    public groupByGrades(objectArray, isSecondStandardExpanded?: boolean, addOnView?: boolean) {
        let link = addOnView
            ? `/add-on/search/?q=*&selected_facet=standard:`
            : `/search/?q=*&selected_facet=standard:`
        const resultGradeBandStandards = {
            "PreK-K": [],
            "K-2": [],
            "3-5": [],
            "6-8": [],
            "9-12": [],
        }
        //new array created after the split in order to sort data by grades -  K-2, 3-5, 6-8, 9-12
        let standardsArray: any = [...objectArray]
        let iterator = 0
        standardsArray.reduce(function (object, item) {
            for (let key = 0; key < item.grade_bands.length; key++) {
                const standardObject = Object.assign({}, item)
                standardObject.link = `${link}${item.id}`
                standardObject.grade_bands = item.grade_bands[key].toString()
                //if a standard has multiple arrays inside - only first 3 items from first array will be displayed
                standardObject.expanded = iterator <= 2 && !isSecondStandardExpanded
                resultGradeBandStandards[item.grade_bands[key]].push(standardObject)
                iterator++
            }
        }, {})
        //array data structure is returned because in object the sort data order is not kept
        return Array.from(Object.entries(resultGradeBandStandards))
    }
}
